var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(
      _vm.editingEndorsement && _vm.editingEndorsement.values && _vm.numberOfWaterCrafts
    )?_c('div',[_vm._v(" "+_vm._s(`Number of watercrafts: ${_vm.numberOfWaterCrafts}`)+" ")]):_vm._e(),(_vm.waterCraftData)?_c('div',_vm._l((Object.keys(_vm.waterCraftData)),function(objectKey,index){return _c('div',{key:index,staticClass:"mt-2"},[_vm._v(" "+_vm._s(`Type of watercraft (Watercraft ${objectKey}): ${_vm.waterCraftData[objectKey]}`)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }